import React from 'react'
import {Button} from 'semantic-ui-react'

class submitButton extends React.Component{
    constructor(props){
        super(props)
        this.callerHandler=props.handleSubmit
        this.disabled=false
    }
    handleSubmit=async(e)=>{
        if(this.disabled) return null
        this.disabled=true
        await this.callerHandler(e)
        this.disabled=false
    }
    render(){
        return (
            <Button className={this.props.className} onClick={this.handleSubmit}>
                {this.props.children}
            </Button>
        )
    }
}
export default submitButton